<template>
  <div class="appcontent">
    <div class="box">
      <div class="boxlist">
        <div class="title">Tokenomics</div>
        <div class="content con">
          The token allocation ratio is designed to ensure the sustainable
          development of the project and incentivize community members, core
          development contributors, early node operators, and others to jointly
          promote the construction of the TFSC network. The initial total supply
          of TFSC tokens is 70,000,000, and the token allocation ratio is as
          shown in the following chart:
        </div>
        <div class="img1" ref="chart" style="width: 345px; height: 360px"></div>
        <!-- <div class="img1">
          <img src="../../../assets/m/Application/tu1.png" />
        </div> -->
        <div class="imglist">
          <div class="imgli">
            <div class="lishang">
              <div class="left left1"></div>
              <div class="center">Operations</div>
              <div class="right">5%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p1"></div>
              </div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left2"></div>
              <div class="center">Global community talent</div>
              <div class="right">5%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p2"></div>
              </div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left3"></div>
              <div class="center">Seed round</div>
              <div class="right">8%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p3"></div>
              </div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left4"></div>
              <div class="center">Core development contributors</div>
              <div class="right">15%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p4"></div>
              </div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left5"></div>
              <div class="center">Ecological development</div>
              <div class="right">25%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p5"></div>
              </div>
            </div>
            <div class="lishang lishanga">
              <div class="center">Defi</div>
              <div class="right">5%</div>
            </div>
            <div class="lishang lishanga">
              <div class="center">Game</div>
              <div class="right">5%</div>
            </div>
            <div class="lishang lishanga">
              <div class="center">Hackathon</div>
              <div class="right">15%</div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left6"></div>
              <div class="center">Airdrop</div>
              <div class="right">10%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p6"></div>
              </div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left7"></div>
              <div class="center">Institutional round</div>
              <div class="right">12%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p7"></div>
              </div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left8"></div>
              <div class="center">Early node delegation fund</div>
              <div class="right">5%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p8"></div>
              </div>
            </div>
          </div>
          <div class="imgli">
            <div class="lishang">
              <div class="left left9"></div>
              <div class="center">Strategic fund</div>
              <div class="right">15%</div>
            </div>
            <div class="lixia">
              <div class="progress">
                <!--进度条-->
                <div class="loader-container p9"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="boxlist">
        <div class="title1">Release <span>Schedule</span></div>
        <div class="content con1">
          The release of TFSC tokens is aimed at ensuring the fair distribution
          of tokens and the sustainable development of the TFSC.
        </div>
        <div class="img2">
          <img src="../../../assets/m/Application/tu2.png" />
        </div>
        <!-- <img src="../../../assets/m/Application/tu2.png" > -->
      </div>
      <div class="bintubox">
        <div
          class="bintu"
          ref="charta"
          style="width: 100%; height: 440px"
        ></div>
      </div>
      <!-- <div class="botton">Start</div> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
const echarts = require("echarts");
import Index from "../Index.vue";
// import { Search } from "vant";
// const echarts = require("echarts");
// Vue.use(Search);
export default {
  components: {
    Index,
    // Search,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    this.initCharts();
    //  this.initChartsa();
    this.initChartsaa();
  },
  destroyed() {},
  methods: {
    format(percentage) {
      return percentage === 100 ? "满" : `${percentage}%`;
    },
    initCharts() {
      var get = function (e) {
        var newStr = " ";
        var start, end;
        var name_len = e.name.length; //每个内容名称的长度
        var max_name = 11; //每行最多显示的字数
        var new_row = Math.ceil(name_len / max_name); // 最多能显示几行，向上取整比如2.1就是3行
        if (name_len > max_name) {
          //如果长度大于每行最多显示的字数
          for (var i = 0; i < new_row; i++) {
            //循环次数就是行数
            var old = ""; //每次截取的字符
            start = i * max_name; //截取的起点
            end = start + max_name; //截取的终点
            if (i == new_row - 1) {
              //最后一行就不换行了
              old = e.name.substring(start);
            } else {
              old = e.name.substring(start, end) + "\n";
            }
            newStr += old; //拼接字符串
          }
        } else {
          //如果小于每行最多显示的字数就返回原来的字符串
          newStr = e.name;
        }
        return newStr;
      };
      // 在调取Echarts实例时判断是否存在，存在就销毁
      if (
        this.lineChart != null &&
        this.lineChart != "" &&
        this.lineChart != undefined
      ) {
        this.lineChart.dispose(); //销毁
      }
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        title: {
          // text: "Referer of a Website",
          // subtext: "Fake Data",
          //left: "center",
        },

        tooltip: {
          //trigger: "item",
          formatter: "{b}：{c}% ",
          extraCssText: "z-index: 0;white-space:pre-wrap",
          // tooltip位置根据鼠标位置而改变
          position(point, params, dom, rect, size) {
            const obj = {};

            // 鼠标的水平位置（point[0]）小于图表容器宽度的一半（size.viewSize[0] / 2）时
            // tooltip显示在右边（right）,反之显示在左边（left）。
            // -100 为位置偏移量，根据具体需求进行调整

            obj[["right", "left"][+(point[0] < size.viewSize[0] / 2)]] = 0;

            // 鼠标的竖直位置（point[1]）小于图表容器高度的一半（size.viewSize[1] / 2）时
            // tooltip显示在底边（bottom）,反之显示在顶边（top）。
            // -58 为位置偏移量，根据具体需求进行调整

            obj[["bottom", "top"][+(point[1] < size.viewSize[1] / 2)]] = -8;
            return obj;
          },
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: "85%",
            minAngle: 15, //最小角度

            avoidLabelOverlap: true, // 是否启用防止标签重叠策略
            data: [
              { value: 5, name: "Operations" },
              { value: 5, name: "Global community talent" },
              { value: 8, name: "Seed round" },
              { value: 15, name: "Core development contributors" },
              {
                value: 25,
                name: "Ecological development",
                name1: "Defi",
                value1: 5,
                name2: "Game",
                value2: 5,
                name3: "Hackathon",
                value3: 15,
              },
              { value: 10, name: "Airdrop" },
              { value: 12, name: "Institutional round" },
              { value: 5, name: "Early node delegation fund" },
              { value: 15, name: "Strategic fund" },
              //  { value: 25, name: "Ecological development",name1:"Defi",value1:5,name2:"Game",value2:5,name3:"Hackathon",value3:15, },
            ],
            itemStyle: {
              borderRadius: 4,
              borderColor: "#fff",
              borderWidth: 1,
              color: function (params) {
                //自定义颜色
                var colorList = [
                  "#F2C3FF ",
                  "#EA9AFF",
                  "#E172FF",
                  "#D949FF",
                  "#D020FF",
                  "#C200F6",
                  "#A200CD",
                  "#8200A5",
                  "#62007C",
                ];
                return colorList[params.dataIndex];
              },
            },
            labelLayout: {
              hideOverlap: false,
            },
            label: {
              show: false,
              // position: "center", //可选参数：外部 “outer” 和内部 “inner”
              formatter: get,
              textStyle: {
                align: "top",
                baseline: "top",
                textShadowOffsetX: 120,
                textShadowOffsetY: 120,
                overflow: "break",
                color: "red",
              },
            },
            lableLine: {
              show: false, //标签视觉引导线 不显示
            },
          },
        ],
      };

      this.lineChart.setOption(option);
    },

    initChartsaa() {
      var datax = [
        "0",
        "6",
        "12",
        "18",
        "24",
        "30",
        "36",
        "42",
        "48",
        "54",
        "60",
      ];

      var dataa = [
        0, 2695000, 5390000, 5572613, 5755226, 5923624, 6092022, 6242129.5,
        6392237, 6520209.5, 6648182,
      ];

      var data1 = [
        145833.3333, 875000, 1750000, 2625000, 3500000, 3500000, 3500000,
        3500000, 3500000, 3500000, 3500000,
      ];

      var data2 = [
        58333.33333, 350000, 700000, 1050000, 1400000, 1750000, 2100000,
        2450000, 2800000, 3150000, 3500000,
      ];

      var data3 = [
        466666.6667, 2800000, 5600000, 5600000, 5600000, 5600000, 5600000,
        5600000, 5600000, 5600000, 5600000,
      ];

      var data4 = [
        145833.3333, 875000, 1750000, 2625000, 3500000, 4375000, 5250000,
        5286458.333, 5468750, 5687500, 5906250,
      ];

      var data5 = [
        145833.3333, 875000, 1750000, 2625000, 3500000, 3500000, 3500000,
        3500000, 3500000, 3500000, 3500000,
      ];
      var data6 = [
        145833.3333, 875000, 1750000, 2625000, 3500000, 3500000, 3500000,
        3500000, 3500000, 3500000, 3500000,
      ];
      var data7 = [
        145833.3333, 875000, 1750000, 2625000, 3500000, 4375000, 5250000,
        5286458.333, 5468750, 5687500, 5906250,
      ];
      var data8 = [
        583333.3333, 3500000, 7000000, 7000000, 7000000, 7000000, 7000000,
        7000000, 7000000, 7000000, 7000000,
      ];
      var data9 = [
        700000, 4200000, 8400000, 8400000, 8400000, 8400000, 8400000, 8400000,
        8400000, 8400000, 8400000,
      ];
      var data10 = [
        97222.22222,
        583333.3333,
        1166666.667,
        1750000,
        2333333.333,
        2916666.667,
        3500000,
        "",
        "",
        "",
        "",
      ];
      let option = {
        backgroundColor: "#FFF",
        tooltip: {
          show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
          trigger: "axis",
          borderWidth: 0,
          confine: true,
          show: true,
          position: "left",

          extraCssText: "z-index: 0;white-space:pre-wrap",
          hideDelay: 5,

          formatter: function (params) {
            // console.log(params);
            //  datas = params;
            // console.log(params);
            let res = "";

            let name = "";
            let value = "";
            let marker = "";
            let zongliang = [];
            params.forEach((item) => {
              name = "Month:" + item.axisValue;
              marker = '<p style="text-align: left">' + item.marker;
              // seriesY = item.seriesName;
              value = +item.value + "</p>";
              value = String(item.value).replace(/^(.*\..{4}).*$/, "$1");
              value = Number(value); // number = 12.3321
              zongliang.push(value);
              res += marker + value;
            });
            var d = 0;
            var sum = 0;
            for (var i = 0; i < zongliang.length; i++) {
              var str = "" + zongliang[i];
              if (str.indexOf(".") != -1) {
                var temp = str.split(".")[1].length;
                d = d < temp ? temp : d;
              }
            }
            var m = Math.pow(10, d);
            for (var i = 0; i < zongliang.length; i++) {
              sum += zongliang[i] * m;
            }
            return (res =
              '<div  style="display:block;text-align:left;">' +
              name +
              "<br />" +
              "Secondary circulation:" +
              "<br />" +
              sum / m +
              "<br />" +
              res +
              "</div>");
          },
        },

        legend: {
          data: [
            "Operations",
            "Global community talent",
            "Seed round",
            "Core development contributors",
            "Defi",
            "Game",
            "Hackathon",
            "Airdrop",
            "Institutional round",
            "Early node delegation fund",
            "Staking bonus",
          ],
          icon: "circle", // 设置legend图标
          bottom: "bottom", //设置legend位置
          itemWidth: 5, // 设置宽度
          itemHeight: 5, // 设置高度
          itemGap: 0, //设置legend项之间的间距
          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            lineHeight: 2,
            fontSize: 15,
            fontWeight: 400,
            color: "#000",
            rich: {
              a: {
                padding: 8,
                lineHeight: 2,
              },
            },
          },
        },
        toolbox: {
          show: false, //工具消失
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          top: "7%",
          left: "2%",
          right: "6%",
          bottom: "36%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: datax,
            smooth: true, // 线条是否平滑
            symbol: "none", // 是否显示节点
            axisLabel: {
              formatter: `{value}Month`, // 在每个x轴坐标都添加了单位
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // min: 0,
            // max: 10500000,
            axisLine: {
              show: true, //y轴线消失
            },
            axisTick: {
              show: true, //y轴坐标点消失
            },
            splitLine: {
              //网格线
              show: false,
            },
            axisLabel: {
              formatter: function (params) {
                //   console.log(params);
                var num = params / 1000000;
                return num + "M";
              },
            },
          },
        ],
        series: [
          {
            name: "Hackathon",
            type: "line",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#FF1744",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#FFC400", //设置折线图颜色
              emphasis: {
                color: "#FFC400",
              },
            },

            areaStyle: {
              color: "#FFC400",
            },
            data: data7,
          },
          {
            name: "Core development contributors",
            type: "line",

            stack: "Total",
            areaStyle: {
              color: "#FF1744",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#40C4FF", //设置折线图颜色
              emphasis: {
                color: "#40C4FF",
              },
            },

            areaStyle: {
              color: "#40C4FF",
            },
            data: data4,
          },
          {
            name: "Global community talent",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#55699B",
            },
            itemStyle: {
              color: "#8D9DC3", //设置折线图颜色
              emphasis: {
                color: "#8D9DC3",
              },
            },

            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            data: data2,
          },

          {
            name: "Game",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#64DD17",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            itemStyle: {
              color: "#64DD17", //设置折线图颜色
              emphasis: {
                color: "#64DD17",
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点
            data: data6,
          },
          {
            name: "Defi",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#3921C4",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#3921C4", //设置折线图颜色
              emphasis: {
                color: "#3921C4",
              },
            },

            areaStyle: {
              color: "#3921C4",
            },
            data: data5,
          },
          {
            name: "Operations",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#FF1744",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#FF1744", //设置折线图颜色
              emphasis: {
                color: "#FF1744",
              },
            },

            areaStyle: {
              color: "#FF1744",
            },
            data: data1,
          },
          {
            name: "Airdrop",
            type: "line",

            stack: "Total",
            areaStyle: {
              color: "#FF1744",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#FF6E40", //设置折线图颜色
              emphasis: {
                color: "#FF6E40",
              },
            },

            areaStyle: {
              color: "#FF6E40",
            },
            data: data8,
          },
          {
            name: "Seed round",

            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#FF1744",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#8C9EFF", //设置折线图颜色
              emphasis: {
                color: "#8C9EFF",
              },
            },

            areaStyle: {
              color: "#8C9EFF",
            },
            data: data3,
          },
          {
            name: "Institutional round",
            type: "line",

            stack: "Total",
            areaStyle: {
              color: "#FF1744",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#7C4DFF", //设置折线图颜色
              emphasis: {
                color: "#7C4DFF",
              },
            },

            areaStyle: {
              color: "#7C4DFF",
            },
            data: data9,
          },
          {
            name: "Staking bonus",
            type: "line",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#FF1744",
            },
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点

            itemStyle: {
              color: "#795548", //设置折线图颜色
              emphasis: {
                color: "#795548",
              },
            },

            areaStyle: {
              color: "#795548",
            },
            data: dataa,
          },
          {
            name: "Early node delegation fund",
            type: "line",
            stack: "Total",
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            showSymbol: false,
            smooth: false, // 线条是否平滑
            symbol: "none", // 是否显示节点
            areaStyle: {
              color: "#E040FB ",
            },
            itemStyle: {
              color: "#E040FB", //设置折线图颜色
              emphasis: {
                color: "#E040FB",
              },
            },
            data: data10,
          },
        ],
      };

      this.lineCharta = echarts.init(this.$refs.charta, "dark");
      this.lineCharta.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
// -webkit-filter: blur(9px);
// filter: blur(9px);

.appcontent {
  width: 750px;

  margin: 0px auto 0px auto;
  background: #f4f4f4;
  text-align: center;
  // height: 100%;
  .box {
    // border: 1px solid red;
    width: 690px;
    margin: 0 auto;
    .boxlist {
      margin-top: 148px;
      text-align: center;
      .title {
        width: 690px;
        height: 94px;
        font-size: 80px;
        font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #000000;
        line-height: 94px;
      }
      .title1 {
        width: 690px;
        height: 94px;
        font-size: 80px;
        font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #000000;
        line-height: 94px;
        word-spacing: -10px;
        span {
          color: #cf61dc;
        }
      }
      .con {
        height: 269px;
      }
      .con1 {
        height: 115px;
        margin-bottom: 80px;
      }
      .content {
        margin-top: 20px;
        width: 690px;
        font-size: 24px;
        font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
        font-weight: 400;
        color: #141414;
        line-height: 38px;
      }
      .img1 {
        img {
          margin-top: 52px;
          width: 390px;
          height: 390px;
        }
      }
      .img2 {
        img {
          width: 690px;
          height: 1504px;
        }
      }
      .imglist {
        // border: 1px solid red;
        width: 690px;
        margin-top: 40px;
        margin-bottom: 40px;
        .imgli {
          width: 550px;
          margin: 40px auto;

          margin-bottom: 40px;
          .lishanga {
            margin-left: 30px;
            margin-top: 12px;
            // border: 1px solid red;
          }
          .lishang {
            display: flex;
            justify-content: space-between;
            align-content: center;
            height: 38px;
            .left1 {
              background: #f2c3ff;
            }
            .left2 {
              background: #ea9aff;
            }
            .left3 {
              background: #e172ff;
            }
            .left4 {
              background: #d949ff;
            }
            .left5 {
              background: #d020ff;
            }
            .left6 {
              background: #c200f6;
            }
            .left7 {
              background: #a200cd;
            }
            .left8 {
              background: #8200a5;
            }
            .left9 {
              background: #62007c;
            }

            .left {
              width: 32px;
              height: 32px;
              // background: #f2c3ff;
              border-radius: 414px 414px 414px 414px;
              opacity: 1;
            }
            .center {
              flex: 1;
              text-align: left;
              margin-left: 20px;
              height: 38px;
              font-size: 24px;
              font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
              font-weight: 400;
              color: rgba(20, 20, 20, 0.8);
              line-height: 38px;
            }
            .right {
              height: 38px;
              font-size: 24px;
              font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
              font-weight: 400;
              color: #141414;
              line-height: 38px;
              margin-right: 20px;
            }
          }
          .lixia {
            width: 482px;
            margin: 0 auto;
            margin-top: 14px;
            margin-left: 50px;
            .progress {
              width: 100%;
              height: 20px;
              border-radius: 738px 738px 738px 738px;
              margin: 0 auto;
              // margin-left: 15%;
              // margin-top: 30%;
              background: #ffffff;
              .p1 {
                background: #f2c3ff;
                width: 5%;
                animation: loader1 1s linear;
              }
              .p2 {
                background: #ea9aff;
                width: 5%;
                animation: loader2 1s linear;
              }
              .p3 {
                background: #e172ff;
                width: 8%;
                animation: loader3 1s linear;
              }
              .p4 {
                background: #d949ff;
                width: 15%;
                animation: loader4 1s linear;
              }
              .p5 {
                background: #d020ff;
                width: 25%;
                animation: loader5 1s linear;
              }
              .p6 {
                background: #c200f6;
                width: 10%;
                animation: loader6 1s linear;
              }
              .p7 {
                background: #a200cd;
                width: 12%;
                animation: loader7 1s linear;
              }
              .p8 {
                background: #8200a5;
                width: 5%;
                animation: loader8 1s linear;
              }
              .p9 {
                background: #62007c;
                width: 15%;
                animation: loader9 1s linear;
              }

              .loader-container {
                height: 20px;
                //width: 55%;
                // background: -webkit-linear-gradient(left, #f2c3ff, #f2c3ff);
                border-radius: 738px 738px 738px 738px;
                box-shadow: inset 0 -2px 2px rgba(0, 0, 0, 0.2);
              }
            }
            @keyframes loader1 {
              0% {
                width: 0%;
              }
              100% {
                width: 5%;
              }
            }
            @keyframes loader2 {
              0% {
                width: 0%;
              }
              100% {
                width: 5%;
              }
            }
            @keyframes loader3 {
              0% {
                width: 0%;
              }
              100% {
                width: 8%;
              }
            }
            @keyframes loader4 {
              0% {
                width: 0%;
              }
              100% {
                width: 15%;
              }
            }
            @keyframes loader5 {
              0% {
                width: 0%;
              }
              100% {
                width: 25%;
              }
            }
            @keyframes loader6 {
              0% {
                width: 0%;
              }
              100% {
                width: 10%;
              }
            }
            @keyframes loader7 {
              0% {
                width: 0%;
              }
              100% {
                width: 12%;
              }
            }
            @keyframes loader8 {
              0% {
                width: 0%;
              }
              100% {
                width: 5%;
              }
            }
            @keyframes loader9 {
              0% {
                width: 0%;
              }
              100% {
                width: 15%;
              }
            }
          }
        }
      }
    }
    .bintubox {
      width: 100%;
      margin: 0 auto;
      margin-top: 100px;

      margin-bottom: 100px;
      background: #fff;
      .bintu {
        width: 100%;
        padding-bottom: 10px;
      }
    }
  }
}
</style>
